var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"site-info-row"},[_c('div',{staticClass:"site-info-row__head"},[_c('div',{staticClass:"site-info-row__title"},[_vm._v("\n\t\t\t"+_vm._s(_vm.title)+"\n\t\t")]),_c('div',{staticClass:"site-info-row__line"})]),_c('div',{staticClass:"site-info-row__body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }